import React from "react";
import { motion } from "framer-motion";
import { ArrowUp, ArrowDown, Clock } from "lucide-react";

function SignalCard({ signal, index = 0 }) {
  const up = signal.direction === "UP";
  const closed = signal.status === "CLOSED";
  const animDelay = Math.min(index * 0.02, 0.2);

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: animDelay }}
      className="surface group rounded-2xl p-5 transition-colors hover:border-white/20"
      style={{ willChange: "transform, opacity" }}
      data-testid="signal-card"
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="font-mono text-sm font-semibold tracking-tight text-white">{signal.pair}</div>
          <div className="mt-1 flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest text-neutral-500">
            <Clock size={10} /> {signal.timeframe}
          </div>
        </div>
        <span className={`rounded-full border px-2 py-0.5 font-mono text-[9px] uppercase tracking-widest ${signal.live ? "border-emerald-400/40 text-emerald-300" : closed ? "border-white/10 text-neutral-500" : "border-white/15 text-neutral-400"}`}>
          {signal.live ? "● Live" : signal.status}
        </span>
      </div>

      <div className="mt-5 flex items-center justify-between">
        <div className={`flex items-center gap-2 font-head text-lg font-bold uppercase tracking-tight ${up ? "text-[#8fd6b4]" : "text-[#e0949c]"}`}>
          <span className={`grid h-7 w-7 place-items-center rounded-lg border ${up ? "border-[#8fd6b4]/30" : "border-[#e0949c]/30"}`}>
            {up ? <ArrowUp size={15} /> : <ArrowDown size={15} />}
          </span>
          {signal.direction}
        </div>
        <div className="text-right">
          <div className="font-mono text-base font-semibold tabular-nums text-white">{signal.confidence}%</div>
          <div className="font-mono text-[9px] uppercase tracking-widest text-neutral-500">confidence</div>
        </div>
      </div>

      <div className="mt-4 h-1 w-full overflow-hidden rounded-full bg-white/6">
        <div
          className="h-full rounded-full"
          style={{ width: `${signal.confidence}%`, background: up ? "#8fd6b4" : "#e0949c", opacity: 0.85 }}
        />
      </div>

      {signal.live && signal.price != null && (
        <div className="mt-3 flex items-center justify-between border-t border-white/6 pt-3 font-mono text-[10px] uppercase tracking-widest text-neutral-500">
          <span>Live price</span>
          <span className="tabular-nums text-neutral-200">{signal.price}</span>
        </div>
      )}
    </motion.div>
  );
}

export default React.memo(SignalCard);
